import React from 'react'
import { Button, Col, Modal, Row } from 'react-angle-dashboard-components'

import { ReactComponent as InfoCircle } from '../../../assets/infoCircle.svg'

interface IEditProposalModalProps {
  open: boolean
  onClose: () => void
  onContinue: () => void
}

const EditProposalModal = ({
  open,
  onClose,
  onContinue
}: IEditProposalModalProps) => {
  return (
    <Modal
      show={open}
      centered
      onHide={onClose}
      dialogClassName="editProposalModalDialog"
      className="editProposalModal"
      style={{
        zIndex: 2000
      }}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Proposal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Col>
          <Row className="d-flex align-items-center justify-content-center">
            <InfoCircle />
          </Row>
          <Row className="text-center mt-3">
            By editing this proposal you are creating a new proposal with all
            the same data that you entered previously. Do you wish to continue?
          </Row>
        </Col>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-primary" onClick={onClose}>
          Close
        </Button>
        <Button onClick={onContinue}>Continue</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditProposalModal
